// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@5.2.7@css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".column-name[data-v-4d2997d4]{align-items:center;display:flex;flex-direction:column;height:258px;justify-content:flex-end}.column-name .column-en[data-v-4d2997d4]{color:#fff;font-size:20px;font-weight:700;line-height:1.1;margin-bottom:36px}.column-name .column-cn[data-v-4d2997d4]{color:#fff;font-size:100px;font-weight:700;line-height:1.1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
